import { render, staticRenderFns } from "./TrainDataList.vue?vue&type=template&id=4023dac7&"
import script from "./TrainDataList.vue?vue&type=script&lang=js&"
export * from "./TrainDataList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports